var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWithFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5237",
    "data-name": "Group 5237",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 9.75,
    cy: 9.75,
    rx: 9.75,
    ry: 9.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M3.96-1.583a.325.325,0,0,1-.238-.1.325.325,0,0,1-.1-.238V-4.654H.945a.325.325,0,0,1-.238-.1.325.325,0,0,1-.1-.238v-.757a.325.325,0,0,1,.1-.238.325.325,0,0,1,.238-.1H3.623V-8.735a.319.319,0,0,1,.1-.245.338.338,0,0,1,.238-.091H4.8a.332.332,0,0,1,.245.091.332.332,0,0,1,.091.245v2.651H7.816a.325.325,0,0,1,.238.1.325.325,0,0,1,.1.238v.757a.338.338,0,0,1-.091.238.319.319,0,0,1-.245.1H5.138V-1.92a.338.338,0,0,1-.091.238.319.319,0,0,1-.245.1Z",
    transform: "translate(5.528 15.208)",
    fill: "#d23b7d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWithFill);
export default __webpack_public_path__ + "static/media/plus-with-fill.352db3e7ba59688d326f0734a524f5f0.svg";
export { ForwardRef as ReactComponent };